import React from 'react';
import { DataPoint } from '../utils/mockData';
interface TimeSliderProps {
  data: DataPoint[];
  currentIndex: number;
  onChange: (index: number) => void;
}
export const TimeSlider: React.FC<TimeSliderProps> = ({
  data,
  currentIndex,
  onChange
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value));
  };
  const formatTimeLabel = (timestamp: Date) => {
    return timestamp.toLocaleString([], {
      month: 'short',
      day: 'numeric',
      hour: window.innerWidth < 640 ? undefined : '2-digit',
      minute: window.innerWidth < 640 ? undefined : '2-digit'
    });
  };
  // Create status markers to visualize transitions on the slider
  const markers = data.map((point, index) => {
    const percentage = index / (data.length - 1) * 100;
    return {
      status: point.healthStatus,
      position: percentage,
      index
    };
  });
  // Group consecutive markers with the same status
  const statusSegments = [];
  let currentSegment = {
    status: markers[0]?.status,
    startIndex: 0,
    endIndex: 0
  };
  markers.forEach((marker, index) => {
    if (marker.status === currentSegment.status) {
      currentSegment.endIndex = index;
    } else {
      statusSegments.push({
        ...currentSegment
      });
      currentSegment = {
        status: marker.status,
        startIndex: index,
        endIndex: index
      };
    }
    // Add the last segment if we're at the end
    if (index === markers.length - 1) {
      statusSegments.push({
        ...currentSegment
      });
    }
  });
  return <div className="space-y-3 sm:space-y-4" data-id="element-245">
      <div className="relative pt-5 sm:pt-6" data-id="element-246">
        <div className="absolute left-0 right-0 h-2 bg-gray-200 rounded overflow-hidden" data-id="element-247">
          {statusSegments.map((segment, i) => {
          const startPercentage = segment.startIndex / (data.length - 1) * 100;
          const endPercentage = segment.endIndex / (data.length - 1) * 100;
          const width = endPercentage - startPercentage + 100 / (data.length - 1);
          return <div key={`segment-${i}`} className={`absolute h-full ${segment.status === 'green' ? 'bg-green-500' : segment.status === 'yellow' ? 'bg-yellow-500' : 'bg-red-500'}`} style={{
            left: `${startPercentage}%`,
            width: `${width}%`,
            zIndex: segment.status === 'green' ? 1 : segment.status === 'yellow' ? 2 : 3
          }} data-id="element-248" />;
        })}
        </div>
      </div>
      <input type="range" min="0" max={data.length - 1} value={currentIndex} onChange={handleChange} className="w-full h-2 bg-transparent appearance-none cursor-pointer touch-manipulation" style={{
      // Custom styling for the slider thumb
      background: 'transparent'
    }} data-id="element-249" />
      <div className="flex justify-between text-xs text-gray-500" data-id="element-250">
        <span className="text-xs" data-id="element-251">{formatTimeLabel(data[0].timestamp)}</span>
        <span className="text-xs hidden sm:inline" data-id="element-252">
          {formatTimeLabel(data[Math.floor(data.length / 2)].timestamp)}
        </span>
        <span className="text-xs" data-id="element-253">
          {formatTimeLabel(data[data.length - 1].timestamp)}
        </span>
      </div>
    </div>;
};